import { FC, useState } from 'react';
import { translate } from 'translations';
import { Tabs } from 'learning-panel-components';
import UsersLeaderboard from './usersLeaderboardContainer';
import TeamsLeaderboard from './playTeamLeaderboardContainer';
import styles from './playLeaderboard.module.scss';

const PlayLeaderboard: FC = () => {
    const [currentTabId, setCurrentTabId] = useState<number>(1);

    return (
        <div className={styles.wrapper}>
            <div className={styles.tabs}>
                <Tabs
                    title={translate('Top10Challengers')}
                    tabs={[
                        { id: 1, title: translate('Users') },
                        { id: 2, title: translate('Teams') }
                    ]}
                    currentTabId={currentTabId}
                    onTabClick={setCurrentTabId}
                />
            </div>
            <div className={styles.leaderboard}>
                {currentTabId === 1 ? <UsersLeaderboard isTournament={false} /> : <TeamsLeaderboard />}
            </div>
        </div>
    );
};

export default PlayLeaderboard;
